export default __webpack_public_path__ + "static/media/green_pulumi.529fab82.svg";